package com.exura.features.publicplans.data.remote.dto

import com.exura.features.storage.domain.model.ModelDto
import kotlinx.serialization.KSerializer
import kotlinx.serialization.Serializable
import kotlinx.serialization.Transient
import kotlin.js.JsName

@Serializable
@JsName("AnonymousPublicPlanOrderDto")
data class AnonymousPublicPlanOrderDto(
    @JsName("sourcePlanId")
    val sourcePlanId: String,
    @JsName("accessedDate")
    val accessedDate: String,
    @JsName("anchorDate")
    val anchorDate: String,
    @JsName("orderDuration")
    val orderDuration: Int,
) : ModelDto<AnonymousPublicPlanOrderDto> {
    @Transient
    override val serializer: KSerializer<AnonymousPublicPlanOrderDto> = serializer()
}
